import firebase from 'utils/firebase';

// TODO create unit test
export const signInWithEmailAndPassword = history => async ({email, password}, actions) => {
  try {
    await firebase.auth().signInWithEmailAndPassword(email, password);
    history.push('/');
  } catch (error) {
    actions.setSubmitting(false);
    actions.setErrors({email: error.message});
  }
};
